// export const DEFAULT_OVERLAY_OPACITY = 0.5;
// export const DEFAULT_DISMISS_ON_OVERLAY_PRESS = true;
// export const DEFAULT_ALLOW_TOUCH_THROUGH_OVERLAY = false;

const DEFAULT_DISMISS_ON_PAN_DOWN = true;

export { DEFAULT_DISMISS_ON_PAN_DOWN };
